import { parseDocumentFromString } from 'anodum';
import blocksConstants from '../../../blocks/constants/common';

const { BLOCK_ID_PREFIX } = blocksConstants;

const getBlockIdsReferenceMap = (sourcePage, targetPage) => {
  const sourcePageBlocks = parseDocumentFromString(sourcePage.html).querySelectorAll(
    `[id^="${BLOCK_ID_PREFIX}"`
  );
  if (!sourcePageBlocks.length) return {};

  const targetPageBlocks = parseDocumentFromString(targetPage.html).querySelectorAll(
    `[id^="${BLOCK_ID_PREFIX}"`
  );

  return [...sourcePageBlocks].reduce(
    (acc, block, index) => ({
      ...acc,
      [block.id]: targetPageBlocks[index].id,
    }),
    {}
  );
};

export default getBlockIdsReferenceMap;
